export default __webpack_public_path__ + "static/media/Broa-De-Noz-2.dc669697.jpg";